export default function header() {
  $('#mobile-menu a[href="#logo"]').parent().remove();

  if ($('.main-menu-desktop a[href="#logo"]').length) {
    const logoContainer  = $('.logo').clone();
    $('.main-menu-desktop a[href="#logo"]').parent().addClass('logo-menu-item');
    $('.main-menu-desktop a[href="#logo"]').replaceWith(logoContainer);
  }

  header_custom_buttons();
  header_search_button();
}

export function sticky_header(initial_scroll = null) {
  var scroll = $(window).scrollTop();
  var navigation_offset = $('.header-container').outerHeight();
  if (initial_scroll && initial_scroll > navigation_offset) {
    $('.header-container').addClass('sticky');
  }
  if (scroll > navigation_offset) {
    $('.header-container').addClass('sticky');
  } else {
    $('.header-container').removeClass('sticky');
  }
}

function header_search_button() {
  $('#searchform div').append('<span id="search-icon"></span><span id="custom-search-btn"><img src="/wp-content/themes/nsgk/img/search.svg"></span>');
  $('#searchform input').attr('placeholder', 'Sök här');
  $('#custom-search-btn').click(function() {
      $( "#searchsubmit" ).trigger( "click" );
  });
}

function header_custom_buttons() {
   $('.menu-custom-buttons-container').appendTo('.mega-menu-container');
}
